import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from '../common/loader';
import '../../common/css/fareList.css';
import { Link, useNavigate } from 'react-router-dom';
import SaveModal from '../modal/saveModal';

function FareIndex() {
    const [FareStatue, setFareStatue] = useState('');
    const [path, setPath] = useState('');
    const [list, setList] = useState([]);
    const [searchData, setSearchData] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [isWait, setIsWait] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [maxPage, setMaxPage] = useState(5);
    const [minPage, setMinPage] = useState(1);

    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    const navigate = useNavigate();

    const checkNoticeStatus = () => {
        const path = window.location.pathname.split('/')[2];
        setPath(path);
        if (path === 'all') {
            setFareStatue('전체 요금 보기');
        } else if (path === 'regular') {
            setFareStatue('정규 포괄 요금');
        } else if (path === 'discount') {
            setFareStatue('정규 특가 요금');
        } else if (path === 'special') {
            setFareStatue('특정일 특가');
        } else{
            window.location.href = '/';
        }
    };

    const pagnation = () => {
        let result = [];
        if (currentPage == 1 || currentPage == 2) {
            for (let index = minPage; index <= maxPage && index <= totalPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPage, currentPage + 2);
            for (let index = startPage; index <= endPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        }
        return result;
    };

    // 페이지 네이션 클래스를 위한 URL 업데이트
    const updateURL = (index) => {
        navigate(`?pageNumber=${index}&search=${searchData}`, { replace: true });
        setCurrentPage(index);
        searchDataResult(index);
    };

    // 이전 및 다음 버튼 클릭 이벤트
    const pagnationBtn = (type) => {
        if (type === 'prev' && currentPage > 1) {
            updateURL(currentPage - 1);

            if (currentPage - 1 < minPage) {
                setMaxPage(maxPage - 1);
                setMinPage(minPage - 1);
            }
        } else if (type === 'next' && currentPage < totalPage) {
            updateURL(currentPage + 1);

            if (currentPage + 1 > maxPage) {
                setMaxPage(maxPage + 1);
                setMinPage(minPage + 1);
            }
        } else {
            alert(type === 'prev' ? '첫번째 페이지입니다.' : '마지막 페이지입니다.');
        }
    };

    // 검색 이벤트
    const searchDataResult = async (pagenumber) => {
        try {
            const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

            const response = await axios.get(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/price/${path}?pageNumber=${pagenumber ?? 1}&search=${searchData}`,
            );

            setList(response.data);
            setTotalPage(Math.ceil(response.data.total / 10));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const faqData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const page = params.get('pageNumber') ?? 1;

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/price/${path}?pageNumber=${page}`,
                );
                setList(response.data);
                setTotalPage(Math.ceil(response.data.total / 10));
                setCurrentPage(page);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (path) {
            faqData();
        }
    }, [path]);

    useEffect(() => {
        checkNoticeStatus();
    }, []);

    // 리스트 map 끝나는 순간
    useEffect(() => {
        if (list?.list && list.list.length > 0) {
            setIsWait(true);
        }
    }, [list]);

    return (
        <>
            {!isWait && <Loader list={'true'} />}

            <div id='contents' className='notice-contents'>
                <div class='subp_h_wrap'>
                    <div class='subp_h_list'>
                        <div class='subp_h_home'></div>
                        <div>운임안내</div>
                        <div>{FareStatue}</div>
                    </div>
                </div>
                <div class='page_hgroup'>
                    <h2 class='title'>{FareStatue}</h2>
                    <div className='fare-sub-title'>
                        본 메뉴는 한국 출발 판매가의 "LOW~"로 시작되는 특가 운임표는 미포함 되며
                        특가 운임의 경우 GDS 시스템 통해 확인 해주시기 바랍니다.
                    </div>
                </div>

                <div class='notice_list_wrap fare_list'>
                    <div class='notice_list'>
                        <div class='list_top_cont'>
                            <p class='pager'>
                                총 <span class='num'>{list.total}</span>건
                            </p>
                            <div class='search_box notice_search_box'>
                                <input
                                    type='text'
                                    class='search'
                                    placeholder='검색어를 입력하세요'
                                    value={searchData}
                                    onChange={(e) => setSearchData(e.target.value)}
                                />
                                <button
                                    class='button'
                                    onClick={() => {
                                        searchDataResult();
                                    }}
                                />
                            </div>
                        </div>

                        <div class='list_cont'>
                            <ul class='list' style={{ margin: '0px' }}>
                                <li style={{ background: '#E9E9E9' }}>
                                    <a>
                                        <span
                                            style={{
                                                width: '5%',
                                                fontsize: '14px',
                                                fontweight: '700',
                                                color: '#222222',
                                            }}
                                        >
                                            No
                                        </span>
                                        <span
                                            class='txt'
                                            style={{
                                                width: '70%',
                                            }}
                                        >
                                            제목
                                        </span>
                                        <span
                                            class='file'
                                            style={{ width: '10%', fontSize: '16px' }}
                                        >
                                            첨부
                                        </span>
                                        <span class='date'>등록일</span>
                                    </a>
                                </li>
                            </ul>
                            <ul class='list'>
                                {list?.list?.map((item, index) => (
                                    <li class='fix' key={index}>
                                        <Link
                                            to={`${window.location.pathname}/detail?idx=${item.postIdx}`}
                                        >
                                            <span class='ico'>{item.postIdx}</span>
                                            <span
                                                class='txt'
                                                style={{
                                                    width: '70%',
                                                    textAlign: 'left',
                                                    marginLeft: '50px',
                                                }}
                                            >
                                                {item.postTitle}
                                            </span>
                                            <span
                                                class={`file ${
                                                    item.hasFile == 1 ? 'hasFile' : 'noneFile'
                                                }`}
                                                style={{ width: '10%' }}
                                            ></span>
                                            <span class='date' style={{ width: '8%' }}>
                                                {item.createDate.split(' ')[0]}
                                            </span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div class='pagenation'>
                            <div class='pagenation_inner'>
                                <a
                                    class={`prev_page`}
                                    onClick={() => {
                                        pagnationBtn('prev');
                                    }}
                                >
                                    이전페이지
                                </a>
                                <ul>{pagnation()}</ul>
                                <a
                                    class={`next_page`}
                                    onClick={() => {
                                        pagnationBtn('next');
                                    }}
                                >
                                    다음페이지
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
            </div>
        </>
    );
}

export default FareIndex;
